import Skeleton from '../Skeleton.jsx';
import ChatPanelComposerSkeleton from './ChatPanelComposerSkeleton.jsx';

/**
 * Inline skeleton while agent details load — mirrors {@link ChatPanelAgentView}
 * (centered hero + composer). Starter cards are omitted until data loads to avoid layout jump when none exist.
 */
const ChatPanelAgentViewSkeleton = () => (
  <div className="flex w-full min-w-0 flex-col gap-6 py-2">
    <div className="flex flex-col items-center gap-3 text-center">
      <Skeleton height={64} width={64} borderRadius={9999} />
      <Skeleton height={28} width={160} borderRadius={6} className="mx-auto" />
      <div className="flex max-w-md items-start justify-center gap-1.5">
        <Skeleton height={16} width={16} borderRadius={4} className="mt-0.5 shrink-0" />
        <div className="flex min-w-0 flex-1 flex-col gap-1.5 text-left">
          <Skeleton height={14} width={280} borderRadius={4} className="max-w-full" />
        </div>
      </div>
      <div className="mx-auto flex w-full max-w-lg flex-col items-center gap-2">
        <Skeleton height={14} width="100%" borderRadius={4} className="max-w-md" />
        <Skeleton height={14} width="92%" borderRadius={4} className="max-w-md" />
        <Skeleton height={14} width="68%" borderRadius={4} className="max-w-md" />
      </div>
    </div>

    <ChatPanelComposerSkeleton />
  </div>
);

export default ChatPanelAgentViewSkeleton;
